import styled from 'styled-components';

const Textbox = styled.input`
  border-radius: 8px;
  border: ${({theme, $invalid}) => theme.input[$invalid ? 'invalid' : 'default'].border};
  background: ${({theme, $invalid}) => theme.input[$invalid ? 'invalid' : 'default'].bg};
  color: ${({theme, $invalid}) => theme.input[$invalid ? 'invalid' : 'default'].text};
  padding: 8px 16px;
  font-size: 18px;
  line-height: 32px;

  &:focus {
    border: ${({theme, $invalid}) => theme.input[$invalid ? 'invalid' : 'focus'].border};
    background: ${({theme, $invalid}) => theme.input[$invalid ? 'invalid' : 'focus'].bg};
    color: ${({theme, $invalid}) => theme.input[$invalid ? 'invalid' : 'focus'].text};
    outline: none;
  }
`;

export default Textbox;
